<template>
  <cdr-grid
    ref="cards"
    class="results-cards"
  >
    <cdr-card
      v-for="course in courses"
      :key="course.key"
      class="results-cards__card"
      data-ui="result-card"
      :data-available-spots="course.availableSpots"
    >
      <div
        :class="getImageClasses(course.disabled)"
        data-ui="result-card-img-container"
      >
        <cdr-img
          :src="course.baseImageUri"
          class="results-cards__image"
          data-ui="result-card-img"
        />
        <div
          v-if="course.badge"
          :class="`results-cards__badge results-cards__badge--${course.badge.type}`"
          data-ui="result-card-badge"
        >
          {{ course.badge.text }}
        </div>
      </div>
      <course-card-component v-bind="course.result" />
    </cdr-card>
  </cdr-grid>
</template>

<script setup>
import { CdrGrid, CdrCard, CdrImg } from '@rei/cedar';
import { ref } from 'vue';
import CourseCardComponent from './CourseCardComponent.vue';

defineOptions({
  name: 'CourseGridComponent',
});

defineProps({
  courses: {
    type: Array,
    required: true,
  },
});

const cards = ref(null);

const getImageClasses = (disabled) => ({
  'results-cards__image-container': true,
  'results-cards__image-container--disabled': disabled,
});
</script>

<style lang="scss" scoped>
@use '@/style/components/search/course-grid-component.scss';
</style>
